import { render, staticRenderFns } from "./GatherTasksManagement.vue?vue&type=template&id=68f064ed&scoped=true"
import script from "./GatherTasksManagement.vue?vue&type=script&lang=js"
export * from "./GatherTasksManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f064ed",
  null
  
)

export default component.exports